import React, { useEffect, useState } from "react";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import { Form } from "react-bootstrap";
import "./Create_Account_Step6.css";
import Full_Screen_Modal from "../../../full-screen-modal/Full_Screen_Modal";
import { useNavigate } from "react-router-dom";
import { Registration_Lottie } from "../../../lotties/registration-lottie/Registration_Lottie";
import { getLevels, registerGymMember } from "../../../../utils/gymOwnerApi";
import axios from "axios";

const Create_Account_Step6 = ({ setStep, formData, setFormData }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const [selected, setSelected] = useState(
    formData?.level_id ? { id: formData.level_id, name: formData.level_name } : null
  );
  const [levelOptions, setLevelOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState("");
  const [apiError, setApiError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const apiLevels = async () => {
    const response = await getLevels();
    if (response.success && response.data) {
      setLevelOptions(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    apiLevels();
  }, []);

  const handleRegister = async () => {
    // Validate level selection
    if (!selected) {
      setError("Please select your physical activity level");
      return;
    }
    // Validate terms
    if (!termsAccepted) {
      setError("Please accept the Terms & Conditions & Privacy Policy to continue");
      return;
    }

    setError("");
    setApiError("");
    setSubmitting(true);

    const payload = {
      ...formData,
      activity_level: selected.id,
    };
    try {
      const response = await registerGymMember(payload);


      if (response.status === 200 || response.status === 201) {
        setShowModal(true);
        setTimeout(() => {
          setShowModal(false);
          setStep(7)
        }, 2500);
      }
    } catch (err) {
      const errMsg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        "Registration failed. Please try again.";
      setApiError(errMsg);
      setTimeout(() => {
        setStep(1)
      }, 5000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="step1_wrapper step3_wrapper step5_wrapper">
      <Form_Header step={6} totalSteps={6} />
      <div className="weight_selection_div business_constitution_div">
        <h2 className="select_title">Physical Activity Level</h2>

        <div className="goal_wrapper">
          {loading ? (
            <p className="text-center">Loading levels...</p>
          ) : (
            <Form>
              {levelOptions.map((level) => (
                <div
                  key={level.id}
                  className={`goal_item ${selected?.id === level.id ? "active" : ""}`}
                  onClick={() => {
                    setSelected({ id: level.id, name: level.name });
                    setError("");
                  }}
                >
                  <span className="goal_text">{level.name}</span>
                  <Form.Check
                    type="radio"
                    name="level"
                    checked={selected?.id === level.id}
                    readOnly
                  />
                </div>
              ))}
            </Form>
          )}

          <div className="terms_wrapper">
            <Form.Check
              type="checkbox"
              id="terms"
              className="terms_check"
              checked={termsAccepted}
              onChange={(e) => {
                setTermsAccepted(e.target.checked);
                setError("");
              }}
              label={
                <span className="terms_span">
                  By continuing, I agree GYMIFY's{" "}
                  <a className="terms_link">Terms & Conditions & Privacy Policy</a>
                </span>
              }
            />
          </div>

          {/* Validation Error */}
          {error && <p className="text-danger text-center mt-2">{error}</p>}

          {/* API Error */}
          {apiError && (
            <div className="alert alert-danger text-center mt-2">{apiError}</div>
          )}
        </div>

        <div className="form_btn_holder">
          {!loading && <>
            <White_Btn btnText="Back" onClick={() => setStep(5)} />
            <Common_Btn
              btnText={submitting ? "Registering..." : "Register"}
              onClick={handleRegister}
              disabled={submitting}
            />
          </>}
        </div>
      </div>

      <Full_Screen_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Registration_Lottie />}
      />
    </section>
  );
};

export default Create_Account_Step6;